import 'vue';
import './helpers.js';
import './config.js';
import { b as registerComponent } from './plugins-6a50b8eb.js';
import './Icon-ea600614.js';
import './FormElementMixin-648192be.js';
import './Input-a080efb8.js';
import './MatchMediaMixin-d82eb550.js';
import './trapFocus-5a175a55.js';
import './DropdownItem-c6a66909.js';
import './Select-29838d17.js';
import { s as script } from './Timepicker-7978ba3d.js';
export { s as OTimepicker } from './Timepicker-7978ba3d.js';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
